import React from 'react';
import { AlertCircle, X } from 'lucide-react';
import { useProductMatrix } from '../contexts/ProductMatrixContext';

interface DisclaimerProps {
  theme?: 'light' | 'dark';
  isAIDrawerOpen?: boolean;
  aiPanelWidth?: number;
}

const Disclaimer: React.FC<DisclaimerProps> = ({ theme = 'light', isAIDrawerOpen = false, aiPanelWidth = 450 }) => {
  const { isDisclaimerDismissed, setIsDisclaimerDismissed } = useProductMatrix();

  // Don't render if dismissed
  if (isDisclaimerDismissed) {
    return null;
  }

  return (
    <div
      className={`fixed top-0 left-0 z-[60] h-14 border-b transition-all duration-300 ${
        theme === 'light'
          ? 'bg-amber-50 border-amber-200'
          : 'bg-amber-950/80 border-amber-600/40'
      }`}
      style={{
        right: isAIDrawerOpen && window.innerWidth >= 1024 ? `${aiPanelWidth}px` : '0'
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center">
        <div className="flex items-center justify-between gap-3 flex-1">
          <div className="flex items-center justify-center gap-3 flex-1">
            <AlertCircle
              className={`flex-shrink-0 w-5 h-5 ${
                theme === 'light'
                  ? 'text-amber-600'
                  : 'text-amber-400'
              }`}
            />
            <p
              className={`text-sm font-medium ${
                theme === 'light'
                  ? 'text-amber-900'
                  : 'text-amber-100'
              }`}
            >
              Product information is still being gathered and validated. Please verify information shown here.
            </p>
          </div>
          <button
            onClick={() => setIsDisclaimerDismissed(true)}
            className={`flex-shrink-0 p-1 rounded transition-colors ${
              theme === 'light'
                ? 'text-amber-600 hover:text-amber-800 hover:bg-black/5'
                : 'text-amber-400 hover:text-amber-200 hover:bg-amber-800/40'
            }`}
            aria-label="Dismiss notice"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
